import { gql } from '@apollo/client';

export const UPDATE_CUSTODY_CHAIN_IN_PROPERTY_ALL_FIELDS = gql`
  mutation addOrUpdateCustodyChainInProperty($input: AddOrUpdateCustodyChainInPropertyInput!) {
    addOrUpdateCustodyChainInProperty(input: $input) {
      clientMutationId
      errors
      propertyUuid
      custodyChainUuid
      custodyChain {
        id
        fromOfficer {
          id
          personalAttribute {
            id
            firstName
            lastName
          }
          deptAttribute {
            badge
            id
            ori {
              id
              oriName
              abbreviation
            }
          }
        }
        custodyChainLocationType {
          id
          name
          oriId
          position
        }
        custodyChainSubLocationType {
          id
          name
          oriId
          position
        }
        evidenceLocationSubLocation {
          id
          location
          subLocation
        }
        evidenceLocationLocation {
          id
          location
        }
        remarks
        transferredAt
        officer {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`